import React, { useState, useEffect } from 'react';
import { GridRowModes } from "@mui/x-data-grid";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { selectStyles } from "views/pages/manage/masters/holidayMaster/common";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { getFormattedDate } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { formatAndConcatenateValues } from './constants';
import ALoader from "views/pages/manage/common/a-loader";

const ListComponent = ({
  loader,
  currentPage = 0,
  currPageSize,
  rowCount,
  nextButtonHandler,
  rows,
}) => {

  const [rowModesModel, setRowModesModel] = useState({});
  const [rowData, setRowData] = useState(rows);

  useEffect(() => setRowData(rows), [rows]);

  const columns = [
    new AGridColDef("created", "Created Date", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.row?.configMasterAudit[0]?.createdOn ? <Tooltip title={`${moment(params?.row?.configMasterAudit[0]?.createdOn).format('DD-MM-YYYY')} ${moment(params?.row?.configMasterAudit[0]?.createdOn).format('hh:mm A')},  by ${params?.row?.configMasterAudit[0]?.createdBy}`}>
          <div className={`ellipsis-text-container`} >{`${moment(params?.row?.configMasterAudit[0]?.createdOn).format('DD-MM-YYYY')} ${moment(params?.row?.configMasterAudit[0]?.createdOn).format('hh:mm A')},  by ${params?.row?.configMasterAudit[0]?.createdBy}`}</div>
        </Tooltip> : <div>-</div>
      )),
    new AGridColDef("refundNo", "Refund Number", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.row?.configMasterAudit ? <Tooltip title={`${params?.row?.configMasterAudit[0]?.refundNumber}`}>
          <div className={`ellipsis-text-container`}>{`${params?.row?.configMasterAudit[0]?.refundNumber}`}</div>
        </Tooltip> : <div>-</div>
      )),
    new AGridColDef("config", "Config Details", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.row?.configMasterAudit ? <Tooltip title={`${formatAndConcatenateValues(params?.row?.configMasterAudit)}`}>
          <div className={`ellipsis-text-container`}>{`${formatAndConcatenateValues(params?.row?.configMasterAudit)}`}</div>
        </Tooltip> : <div>-</div>
      )),
    new AGridColDef("roleApproval", "Role Approval", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.row?.roleApprovalAudit ? <Tooltip title={`${formatAndConcatenateValues(params?.row?.roleApprovalAudit)}`}>
          <div className={`ellipsis-text-container`}>{`${formatAndConcatenateValues(params?.row?.roleApprovalAudit)}`}</div>
        </Tooltip> : <div>-</div>
      )),
    new AGridColDef("updatedBy", "Last Updated", false)
      .setMinWidth(100)
      .editable(true)
      .setFlex(2)
      .renderCellComponent((params) => (
        params?.row?.configMasterAudit ? <Tooltip title={`${moment(params?.row?.configMasterAudit[0]?.updatedOn).format('DD-MM-YYYY')} ${moment(params?.row?.configMasterAudit[0]?.updatedOn).format('hh:mm A')},  by ${params?.row?.configMasterAudit[0]?.updatedBy}`}>
          <div className={`ellipsis-text-container`} >{`${moment(params?.row?.configMasterAudit[0]?.updatedOn).format('DD-MM-YYYY')} ${moment(params?.row?.configMasterAudit[0]?.updatedOn).format('hh:mm A')},  by ${params?.row?.configMasterAudit[0]?.updatedBy}`}</div>
        </Tooltip> : <div>-</div>
      )),
  ];

  return (
    <>
      <div className="mt-3">
        <ADataGrid
          removeWrapperContainer
          rowModesModel={rowModesModel}
          rows={rowData || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          rowCount={rowCount}
          loading={false}
          currentPage={currentPage}
          nextButtonHandler={nextButtonHandler}
          sx={{
            ...gridStyles,
          }}
          autoHeight
          paginationModel={{ page: currentPage, pageSize: currPageSize }}
        />
      </div>
    </>
  )
}

export default ListComponent;